import { useEffect, useMemo, type FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import useRoutes from './myRoutes';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import useAnalytics from '../hooks/useAnalytics';

interface MyRouterProps {}

const MyRouter: FC<MyRouterProps> = () => {
  const { isAuth } = useSelector((state: RootState) => state.isAuth);
  const { privateRoutes, publicRoutes } = useRoutes();
  const { trackPageView } = useAnalytics();

  const routes = useMemo(() => {
    const baseRoutes = [...publicRoutes];
    isAuth && baseRoutes[0].children?.push(...privateRoutes);

    return baseRoutes;
  }, [isAuth, privateRoutes, publicRoutes]);

  const router = useMemo(() => createBrowserRouter(routes), [routes]);

  useEffect(() => {
    const unsubscribe = router.subscribe(() => {
      const location = router.state.location;
      if (location) trackPageView(location.pathname + location.search);
    });
    return unsubscribe;
  }, [router, trackPageView]);

  return <RouterProvider key={isAuth ? 'auth' : 'guest'} router={router} />;
};

export default MyRouter;
